import React, { CSSProperties, useEffect, useRef } from 'react'

import styled from 'styled-components'
import { TransitionStatus } from 'react-transition-group'
import { Icon, STYLED_VARIABLES } from '@cloudike/web_ui_components'

import { INotification, NOTIFICATION_TYPES } from './types'

interface NotificationProps {
    className?: string,
    notification: INotification,
    style?: CSSProperties,
    state: TransitionStatus,
    isPreviewOpen?: boolean,
    onClick: (notification: INotification) => void,
    onSetHeight: (height: number) => void
}

export const Notification: React.FC<NotificationProps> = ({
  className = '',
  notification,
  style,
  state,
  isPreviewOpen,
  onClick,
  onSetHeight
}) => {
  const handleClick = () => {
    onClick(notification)
  }

  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    onSetHeight(ref.current.getBoundingClientRect().height)
  }, [])

  return (
    <NotificationsBox
      zIndex={isPreviewOpen ? '18' :  '15'}
      position={isPreviewOpen ? 'absolute' : 'unset'}
      className={className}
      style={style}
      state={state}
      onClick={handleClick}
      ref={ref}
    >
      <NotificationTypeIcon
        iconName={(notification.type === NOTIFICATION_TYPES.SUCCESS || notification.type === NOTIFICATION_TYPES.CONSTANT_SUCCESS) ? 'CheckCircle' : 'WarningIcon'}
        id={notification.type}
      />

      <Text>
        {!!notification.message && (
          <Description>
            {notification.message}
          </Description>
        )}

        <Title>
          {notification.title}
        </Title>
      </Text>

      {!!notification.suffixText && (
        <SSuffixText>
          {notification.suffixText}
        </SSuffixText>
      )}

      {!!notification.callback && !notification.withHiddenArrow && <ArrowIcon iconName="ArrowForward" />}
    </NotificationsBox>
  )
}

const NotificationsBox = styled.div<{zIndex:string, position: string}>`
  background-color: var(--background-toast-primary);
  color: var(--text-toast-primary);
  display: flex;
  align-items: center;
  padding: 16px;
  border-radius: 4px;
  box-shadow: 0 4px 4px rgb(0 0 0 / 8%);
  max-width: unset;
  width: unset;
  position: ${(props) => props.position};
  cursor: pointer;
  user-select: none;
  transition: all ease .5s;
  margin: 0 8px 8px;
  bottom: 0;
  order: 1;
  z-index: ${(props) => props.zIndex};
  
  @media screen and (min-width: ${STYLED_VARIABLES.BREAKPOINTS.PHONE_100}) {
    left: 24px;
    bottom: 24px;
    width: 440px;
    transform: translateY(100%);
  }

  @media screen and (max-width:${STYLED_VARIABLES.BREAKPOINTS.PHONE_100}) {
  width: calc(100% - 16px);
}
`

const NotificationTypeIcon = styled(Icon)`
  width: 24px;
  height: 24px;
`

const Text = styled.div`
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  width: 80%;
`

const Title = styled.span`
  margin-right: 16px;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 140%;
`

const Description = styled.span`
  margin-bottom: 1px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 140%;
`

const ArrowIcon = styled(Icon)`
  margin-left: auto;
  width: 24px;
  height: 24px;
`

const SSuffixText = styled.p`
  margin-left: auto;
  margin-right: 16px;
  white-space: nowrap;
  color: var(--text-toast-primary);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 128.906%;
`
